import React, { Fragment } from 'react';
import classNames from 'classnames';

export default function Error({
    error,
    left,
    center
}) {

    const ErrorClasses = classNames({
        "input-error text-red text-xs pt-1": true,
        "text-center": center,
        "text-left": left
    })

    if(!error) return <Fragment />;

    return (
        <div className={ErrorClasses}>{error}</div>
    )
}
